<template>
    <small>
        <input ref="file" name="file" type="file" style="position:absolute;left:-999px;" multiple />
        <input ref="folder" name="file" type="file" style="position:absolute;left:-999px;" multiple webkitdirectory=""
            directory="" />
        <div class="upload-area">
            <div v-if="downloadVisible" class="upload-manager">
                <div class="header">
                    <h4 v-if="downloadTasks.length > 0" class="modal-title">{{ downloadTotalPercent }}%
                        {{ downloadedFiles }}/{{ downloadTotalFiles }}
                        {{ downloadedBytes }}/{{ downloadTotalBytes }}</h4>
                    <div v-else class="d-flex w-100">
                        <h4 class="d-flex align-items-center" style="padding-right:1rem;margin:0px;">
                            {{ $tr("Загрузка") }}</h4>
                        <v-spacer></v-spacer>
                        <v-progress-circular indeterminate color="primary" :size="24" :width="2"></v-progress-circular>
                    </div>
                    <tool-button v-if="downloadTasks.length > 0"
                        :icon="downloadExpanded ? 'chevron-down' : 'chevron-up'" :onclick="onDownloadExpand" />
                </div>
                <div v-if="downloadExpanded">
                    <table style="width:100%;">
                        <tbody>
                            <tr v-for="(task, index) in downloadTasks" :key="index">
                                <td class="d-flex w-100">
                                    {{ task.name }}
                                    <v-spacer></v-spacer>
                                    <v-progress-circular indeterminate
                                        :color="task.progress == 0 ? 'secondary' : 'primary'" :size="18" :width="2">
                                    </v-progress-circular>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-if="downloadFinishedSuccess != undefined" class="upload-manager">
                <div class="header">
                    <h4 class="modal-title">{{ downloadFinishedSuccess }}</h4>
                </div>
            </div>

            <div v-if="uploadVisible" class="upload-manager" style="margin-top:0.5rem;">
                <div class="header">
                    <h4 class="modal-title">{{ uploadTotalPercent }}% {{ uploadedFiles }}/{{ uploadTotalFiles }}
                        {{ uploadedBytes }}/{{ uploadTotalBytes }}</h4>
                    <tool-button :icon="uploadExpanded ? 'chevron-down' : 'chevron-up'" :onclick="onUploadExpand" />
                </div>
                <div v-if="uploadExpanded">
                    <table style="width:100%;">
                        <tbody>
                            <tr v-for="(task, index) in uploadTasks" :key="index">
                                <td style="width:200px;">{{ task.name }}</td>
                                <td>
                                    <v-progress-linear :value="Math.abs(task.progress)"
                                        :color="task.progress == 100 ? 'success' : (task.progress == -100 ? 'error' : 'cyan')"
                                        height="16">
                                        <template v-slot:default>
                                            {{task.progress == 100 ? $tr('Загружен') : (task.progress == -100 ? $tr('Ошибка') : task.progress + '%') }}
                                        </template>
                                    </v-progress-linear>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-if="uploadFinishedSuccess != undefined" class="upload-manager">
                <div class="header">
                    <h4 class="modal-title">{{ uploadFinishedSuccess }}</h4>
                </div>
            </div>
        </div>
    </small>
</template>

<script>
import {
    reactive,
} from 'vue';
import {
    saveAs,
} from 'file-saver';
import Utils from '@topomatic/tap/src/utils';
import ToolButton from '@topomatic/tap/src/components/ToolButton.vue';
import Zip from '@topomatic/tap/src/zip';
import { ZipFile } from '@topomatic/tap/src/unzip';
import { localization } from '@topomatic/tap/src/l10n';
import Dialog from '@topomatic/tap/src/dialog';
import DialogInput from '@topomatic/tap/src/components/DialogInput.vue';
import AppConsts from '../consts';

const upload_tasks = [];
const download_promises = [];
const download_data = [];
const state = reactive({
    upload: {
        expaned: true,
        total_bytes: 0,
        uploaded_bytes: 0,
        total_files: 0,
        uploaded_files: 0,
        error_files: 0,
        query: [],
        ids: [],
        lid: 0,
        finished: false,
    },
    download: {
        counter: 0,
        expaned: true,
        total_bytes: 0,
        downloaded_bytes: 0,
        total_files: 0,
        downloaded_files: 0,
        error_files: 0,
        query: [],
        ids: [],
        lid: 0,
        finished: false,
    },
});

class UploadTask {
    constructor(id, files, permissions) {
        for (let i = files.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            const temp = files[i];
            files[i] = files[j];
            files[j] = temp;
        }
        this.id = id;
        this.files = files;
        this.permissions = permissions;
        let size = 0;
        for (let i = 0; i < files.length; i++) {
            size += files[i].size || 100;
        }
        this.size = size;
    }
}

function uploadFolder(api, id, cache, path) {
    return new Promise((resolve, reject) => {
        if (path == '') {
            resolve(id);
        } else {
            const index = path.indexOf('/');
            const folder = index > 0 ? path.substring(0, index) : path;
            const rest = index > 0 ? path.substring(index + 1) : '';
            let cached = cache[id];
            if (cached == undefined) {
                api.getFiles(id, 0, false)
                    .then((data) => {
                        cached = {};
                        const { files } = data;
                        for (let i = 0; i < files.length; i++) {
                            const file = files[i];
                            if (file.type == AppConsts.FOLDER_TYPE) {
                                cached[file.name.toLowerCase()] = file.id;
                            }
                        }
                        cache[id] = cached;
                        uploadFolder(api, id, cache, path)
                            .then(resolve)
                            .catch(reject);
                    })
                    .catch(reject);
            } else {
                let sid = cached[folder.toLowerCase()];
                if (sid == undefined) {
                    api.addFolder(folder, id)
                        .then((data) => {
                            sid = data.file.id;
                            cached[folder.toLowerCase()] = sid;
                            if (rest == '') {
                                resolve(sid);
                            } else {
                                uploadFolder(api, sid, cache, rest)
                                    .then(resolve)
                                    .catch(reject);
                            }
                        })
                        .catch(reject);
                } else if (rest == '') {
                    resolve(sid);
                } else {
                    uploadFolder(api, sid, cache, rest)
                        .then(resolve)
                        .catch(reject);
                }
            }
        }
    });
}

function readFile(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function () {
            const arrayBuffer = this.result;
            resolve(new Uint8Array(arrayBuffer));
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
    });
}

async function uploadTemplate(api, id, cache, file, tid) {
    const name = file.fullPath || file.webkitRelativePath || file.name || file.fileName;
    const existingFiles = await api.getFiles(id, 1, false);
    const payload = {
        title: localization.tr('Новый проект'),
        ok: localization.tr('Создать'),
        placeholder: localization.tr('Название проекта'),
        value: name.substring(0, name.length - 4),
        focus: true,
        validate: (value) => {
            if ((value || '').trim().length === 0) {
                return localization.tr('Введите название проекта');
            }
            if (existingFiles.files.find((obj) => obj.name.toLowerCase() === value.toLowerCase()) !== undefined) {
                return localization.tr('Проект уже существует');
            }
            return true;
        },
    };
    await Dialog(DialogInput, payload);
    const folder = await api.addFolder(payload.value, id);
    const allUsers = new Set();
    const allGroups = new Set();
    const data = await readFile(file);
    const zip = new ZipFile(data);
    const files = [];
    const permissions = {};
    let storageId = id;
    let storage = await api.getFile(storageId, false, true);
    if (storage.path.length > 0) {
        let minDepthFile = storage.path[0];
        storage.path.forEach((item) => {
            minDepthFile = item.depth < minDepthFile.depth ? item : minDepthFile;
        });
        storageId = minDepthFile.id;
        storage = await api.getFile(storageId);
    }
    for (const entryName in zip.entries) {
        const zipEntry = await zip.readEntry(zip.entries[entryName]);
        const fileItem = new File([new Blob([zipEntry])], entryName);
        if (entryName.endsWith('__metadata__.json')) {
            const dataFile = await readFile(fileItem);
            const rules = JSON.parse(new TextDecoder('utf-8').decode(dataFile));
            for (const rule of Object.values(rules)) {
                if (rule.users) {
                    for (const uid of Object.keys(rule.users)) allUsers.add(uid);
                }
                if (rule.groups) {
                    for (const grid of Object.keys(rule.groups)) allGroups.add(grid);
                }
            }
            const idx = fileItem.name.lastIndexOf('/');
            let path = '/';
            if (idx > 0) {
                path = fileItem.name.substring(0, idx);
            }
            permissions[`${path}`] = rules;
        } else files.push(fileItem);
    }
    const storageUsers = storage.file.users || {};
    const storageGroups = storage.file.groups || {};
    for (const uId of allUsers) {
        if (!storageUsers[uId]) {
            await api.changeUserPermissions(storageId, uId, 1);
        }
    }
    for (const groupId of allGroups) {
        if (!storageGroups[groupId]) {
            await api.changeGroupPermissions(storageId, groupId, 1);
        }
    }
    const task = new UploadTask(folder.file.id, files, permissions);
    state.upload.uploaded_bytes = 0;
    state.upload.total_bytes = task.size;
    state.upload.uploaded_files = 0;
    state.upload.error_files = 0;
    state.upload.total_files = files.length;
    upload_tasks.push(task);
    return tid;
}

function uploadFile(api, id, cache, file, tid, permissions) {
    let name = file.fullPath || file.webkitRelativePath || file.name || file.fileName;
    if (name.endsWith('.mtf')) {
        return uploadTemplate(api, id, cache, file, tid);
    }
    const idx = name.lastIndexOf('/');
    let path = '';
    if (idx > 0) {
        path = name.substring(0, idx);
        name = name.substring(idx + 1);
    }
    const rsize = file.size || 100;
    return new Promise((resolve) => {
        uploadFolder(api, id, cache, path)
            .then((folder) => {
                if (permissions) {
                    api.getFile(folder).then((folderData) => {
                        if (name === '') {
                            name = path.substring(path.lastIndexOf('/') + 1);
                            path = path.substring(0, path.lastIndexOf('/'));
                        }
                        applyPermissions(folderData.file, path, permissions, api);
                    });
                }
                let lsize = 0;
                const progress = function (value) {
                    const nidx = state.upload.ids.indexOf(tid);
                    state.upload.query[nidx].progress = value;
                    const delta = Math.round((Math.abs(value) * rsize) / 100) - lsize;
                    state.upload.uploaded_bytes += delta;
                    lsize += delta;
                };
                if (name !== '') {
                    api.uploadFile(folder, name, file.type || 'application/octet-stream', file, progress)
                        .then((data) => {
                            if (permissions) {
                                applyPermissions(data.file, path, permissions, api);
                            }
                            progress(100);
                            state.upload.uploaded_files += 1;
                            resolve(tid);
                        })
                        .catch(() => {
                            progress(-100);
                            state.upload.uploaded_files += 1;
                            state.upload.error_files += 1;
                            resolve(tid);
                        });
                } else {
                    progress(100);
                    state.upload.uploaded_files += 1;
                    resolve(tid);
                }
            })
            .catch(() => {
                state.upload.uploaded_files += 1;
                state.upload.error_files += 1;
                state.upload.uploaded_bytes += rsize;
                resolve(tid);
            });
    });
}

async function applyPermissions(f, path, permissions, api) {
    if (path === '') path = '/';
    const permissionsEntry = permissions[path];
    for (const entry of Object.values(permissionsEntry ?? {})) {
        if (f.name === entry.name) {
            for (const user in entry.users) {
                api.changeUserPermissions(f.id, user, entry.users[user]);
            }
            for (const group in entry.groups) {
                api.changeGroupPermissions(f.id, group, entry.groups[group]);
            }
        }
    }
}

function trimFilename(name) {
    if (name.length > 22) {
        return `${name.substring(0, 10)}..${name.substring(name.length - 10)}`;
    }
    return name;
}

function formatFilename(name) {
    const index1 = name.lastIndexOf('/');
    if (index1 > 0) {
        const lname = trimFilename(name.substring(index1));
        const index2 = name.lastIndexOf('/', index1 - 1);
        if (index2 > 0) {
            return `..${trimFilename(name.substring(index2, index1))}${lname}`;
        }
        return trimFilename(name.substring(0, index1)) + lname;
    }
    return trimFilename(name);
}

async function uploadMain(api) {
    state.upload.finished = false;
    const cache = {};
    const promises = [];
    const resolve = function (id) {
        const index = state.upload.ids.indexOf(id);
        state.upload.query.splice(index, 1);
        state.upload.ids.splice(index, 1);
        promises.splice(index, 1);
    };
    for (;;) {
        if (upload_tasks.length == 0) {
            if (promises.length > 0) {
                await Promise.race(promises);
                continue;
            }
            break;
        }
        while (promises.length >= 6) {
            await Promise.race(promises);
        }
        const task = upload_tasks[0];
        if (task.files.length == 0) {
            upload_tasks.splice(0, 1);
        } else {
            const file = task.files.pop();
            const tid = ++state.upload.lid;
            const name = formatFilename(file.fullPath || file.webkitRelativePath || file.name || file.fileName);
            state.upload.ids.push(tid);
            state.upload.query.push({
                name,
                progress: 0,
            });
            promises.push(uploadFile(api, task.id, cache, file, tid, task.permissions).then(resolve));
        }
    }
    state.upload.finished = true;
    setTimeout(() => {
        state.upload.finished = false;
    }, 10000);
}

function findRevision(file) {
    const { revision } = file;
    if (revision != undefined) {
        const { revisions } = file;
        if (revisions != undefined) {
            for (let i = 0; i < revisions.length; i++) {
                if (revisions[i].id == revision) {
                    return revisions[i];
                }
            }
        }
    }
    return undefined;
}

function findPath(file, folders) {
    const folder = folders[file.parent];
    if (folder == undefined) {
        return file.name;
    }
    return `${findPath(folder, folders)}/${file.name}`;
}

function downloadFile(api, file, tid) {
    return new Promise((resolve) => {
        api.downloadFile(file.id, file.revision.id)
            .then((req) => {
                const index = state.download.ids.indexOf(tid);
                const data = download_data[index];
                state.download.query[index].progress = 1;
                const array = req.arrayBuffer();
                array.then((buffer) => {
                    data.buffer = buffer;
                    state.download.downloaded_files += 1;
                    state.download.downloaded_bytes += file.revision.length;
                    resolve(tid);
                });
                array.catch(() => {
                    state.download.downloaded_files += 1;
                    state.download.error_files += 1;
                    state.download.downloaded_bytes += file.revision.length;
                    resolve(tid);
                });
            })
            .catch(() => {
                state.download.downloaded_files += 1;
                state.download.error_files += 1;
                state.download.downloaded_bytes += file.revision.length;
                resolve(tid);
            });
    });
}

async function downloadMain(api, items, getMetadata) {
    let total_files = 0;
    let total_bytes = 0;
    const map = {};
    const folders = {};
    const tasks = [];
    const ownids = {};
    for (let i = 0; i < items.length; i++) {
        const file = items[i];
        let files = map.null;
        if (files == undefined) {
            files = [];
            map.null = files;
        }
        files.push(file);
        if (file.type == AppConsts.FOLDER_TYPE) {
            folders[file.id] = file;
            const childs = file.files;
            if (childs != undefined) {
                for (let j = 0; j < childs.length; j++) {
                    const child = childs[j];
                    files = map[child.parent];
                    if (files == undefined) {
                        files = [];
                        map[child.parent] = files;
                    }
                    files.push(child);
                    if (child.type != AppConsts.FOLDER_TYPE) {
                        child.revision = findRevision(child);
                        if (child.revision != undefined) {
                            total_bytes += child.revision.length;
                        }
                        total_files += 1;
                        tasks.push(child);
                    } else {
                        folders[child.id] = child;
                    }
                }
            } else {
                total_files += 1;
                tasks.push(file);
            }
        } else {
            file.revision = findRevision(file);
            if (file.revision != undefined) {
                total_bytes += file.revision.length;
            }
            total_files += 1;
            tasks.push(file);
        }
    }
    if (tasks.length > 0 || (getMetadata && Object.keys(folders).length > 0)) {
        if (state.download.query.length == 0) {
            state.download.total_bytes = total_bytes;
            state.download.total_files = total_files;
            state.download.downloaded_bytes = 0;
            state.download.downloaded_files = 0;
            state.download.error_files = 0;
        } else {
            state.download.total_bytes += total_bytes;
            state.download.total_files += total_files;
        }
        state.download.finished = false;
        const templateRoot = items.length == 1 ? items[0].name : null;
        const fType = getMetadata ? '.mtf' : '.zip';
        const save = function (blob) {
            if (items.length == 1) {
                let { name } = items[0];
                if (tasks.length > 1 || getMetadata) {
                    name += fType;
                }
                saveAs(blob, name);
            } else {
                api.getFile(items[0].parent, false, false)
                    .then((data) => {
                        saveAs(blob, `${data.file.name}${fType}`);
                    });
            }
        };
        let zip = null;
        if ((tasks.length > 1) || (Object.keys(folders).length > 0)) {
            zip = new Zip();
        }
        if (!getMetadata && Object.keys(folders).length > 0) {
            for (const filesArray of Object.values(map)) {
                for (const folder of filesArray) {
                    let folderPath = findPath(folder, folders);
                    if (templateRoot == folderPath) continue;
                    folderPath = folderPath.substring(folderPath.lastIndexOf('/'), folderPath.length);
                    if (folder.type === AppConsts.FOLDER_TYPE) zip.write(folderPath); // a/b/c/
                }
            }
        }
        if (getMetadata && Object.keys(folders).length > 0) {
            for (const filesArray of Object.values(map)) {
                const folderMetadata = [];
                for (const folder of filesArray) {
                    const folderPath = findPath(folder, folders);
                    if (templateRoot == folderPath) continue;
                    if (folder.type === AppConsts.FOLDER_TYPE) zip.write(folderPath.substring(templateRoot.length + 1)); // a/b/c/
                    const metadata = await createMetadata(api, folder, folders);
                    folderMetadata.push(metadata);
                    let parentfolderPath = folderPath.substring(0, folderPath.lastIndexOf('/') + 1);
                    if (templateRoot) parentfolderPath = parentfolderPath.slice(templateRoot.length + 1);
                    zip.write(`${parentfolderPath}__metadata__.json`, new TextEncoder().encode(JSON.stringify(folderMetadata)));
                }
            }
        } else if (getMetadata) {
            const folderPath = findPath(items[0], folders);
            const metadata = await createMetadata(api, items[0], folders);
            let parentfolderPath = folderPath.substring(0, folderPath.lastIndexOf('/') + 1);
            if (templateRoot) parentfolderPath = parentfolderPath.slice(templateRoot.length + 1);
            zip.write(`${parentfolderPath}`);
            zip.write(`${parentfolderPath}__metadata__.json`, new TextEncoder().encode(JSON.stringify(metadata)));
        }
        const resolve = function (id) {
            const index = state.download.ids.indexOf(id);
            const data = download_data[index];
            delete ownids[id];
            state.download.query.splice(index, 1);
            state.download.ids.splice(index, 1);
            download_promises.splice(index, 1);
            download_data.splice(index, 1);
            if (data.buffer != undefined) {
                if (zip != undefined) {
                    let realPath = data.path;
                    if (getMetadata && templateRoot) realPath = realPath.slice(templateRoot.length + 1);
                    zip.write(realPath, data.buffer);
                } else {
                    save(new Blob([new Uint8Array(data.buffer)], {
                        type: data.type,
                    }));
                }
            }
        };
        for (let i = 0; i < tasks.length; i++) {
            while (download_promises.length >= 6) {
                await Promise.race(download_promises);
            }
            const file = tasks[i];
            if (file.revision != undefined) {
                const tid = ++state.download.lid;
                const fullpath = findPath(file, folders);
                const name = formatFilename(fullpath);
                state.download.ids.push(tid);
                state.download.query.push({
                    name,
                    progress: 0,
                });
                download_data.push({
                    file,
                    path: fullpath,
                    buffer: null,
                    type: file.type,
                });
                const promise = downloadFile(api, file, tid).then(resolve);
                ownids[tid] = promise;
                download_promises.push(promise);
            } else {
                state.download.error_files += 1;
                state.download.downloaded_files += 1;
            }
        }
        const promises = [];
        const keys = Object.keys(ownids);
        for (let i = 0; i < keys.length; i++) {
            promises.push(ownids[keys[i]]);
        }
        if (promises.length > 0) {
            await Promise.all(promises);
        }
        if (zip != undefined) {
            await zip.dispose()
                .then((blob) => {
                    save(blob);
                });
        }
    }
    state.download.counter -= 1;
    if (state.download.counter == 0) {
        state.download.finished = true;
        setTimeout(() => {
            state.download.finished = false;
        }, 10000);
    }
}

function mergeItems(parentItems, goalItems) {
    if (Object.keys(goalItems).length === 0) {
        goalItems = parentItems;
    } else if (Object.keys(goalItems).length !== Object.keys(parentItems).length) {
        for (const itemId in parentItems) {
            if (!goalItems[itemId]) {
                goalItems[itemId] = parentItems[itemId];
            }
        }
    }
    return goalItems;
}
async function createMetadata(api, folder, folders) {
    let users = folder?.users || {};
    let groups = folder?.groups || {};
    let parentUsers = {};
    let parentGroups = {};
    if (!folders[folder.parent]) {
        const data = await api.getFile(folder.parent, true, true);
        parentUsers = data?.file?.users || {};
        parentGroups = data?.file?.groups || {};
    } else {
        const parentFolder = folders[folder.parent];
        const parentMetadata = await createMetadata(api, parentFolder, folders);
        parentUsers = parentMetadata.users;
        parentGroups = parentMetadata.groups;
    }
    users = mergeItems(parentUsers, users);
    groups = mergeItems(parentGroups, groups);
    return {
        name: folder.name,
        type: folder.type,
        users,
        groups,
    };
}

export default {
    name: 'UploadView',
    props: {
        id: String,
    },
    components: {
        ToolButton,
    },
    computed: {
        uploadTasks() {
            return state.upload.query;
        },
        uploadVisible() {
            return state.upload.query.length > 0;
        },
        uploadTotalPercent() {
            if (state.upload.total_bytes > 0) {
                return Math.round((state.upload.uploaded_bytes * 100) / state.upload.total_bytes);
            }
            return undefined;
        },
        uploadTotalFiles() {
            return state.upload.total_files;
        },
        uploadedFiles() {
            return state.upload.uploaded_files;
        },
        uploadTotalBytes() {
            return Utils.sizeToString(state.upload.total_bytes);
        },
        uploadedBytes() {
            return Utils.sizeToString(state.upload.uploaded_bytes);
        },
        uploadFinishedSuccess() {
            if (!state.upload.finished) {
                return undefined;
            }
            return this.$tr('Загружено {0} из {1} файлов').replace('{0}', state.upload.uploaded_files - state.upload.error_files).replace('{1}', state.upload.total_files);
        },
        uploadExpanded() {
            return state.upload.expaned;
        },
        downloadTasks() {
            return state.download.query;
        },
        downloadVisible() {
            return state.download.counter > 0;
        },
        downloadTotalPercent() {
            if (state.download.total_bytes > 0) {
                return Math.round((state.download.downloaded_bytes * 100) / state.download.total_bytes);
            }
            return undefined;
        },
        downloadTotalFiles() {
            return state.download.total_files;
        },
        downloadedFiles() {
            return state.download.downloaded_files;
        },
        downloadTotalBytes() {
            return Utils.sizeToString(state.download.total_bytes);
        },
        downloadedBytes() {
            return Utils.sizeToString(state.download.downloaded_bytes);
        },
        downloadFinishedSuccess() {
            if (!state.download.finished) {
                return undefined;
            }
            return this.$tr('Скачано {0} из {1} файлов').replace('{0}', state.download.downloaded_files - state.download.error_files).replace('{1}', state.download.total_files);
        },
        downloadExpanded() {
            return state.download.expaned;
        },
    },
    methods: {
        uploadFolder() {
            this.$nextTick(() => {
                this.uploadInput(this.$refs.folder);
            });
        },
        uploadFile() {
            this.$nextTick(() => {
                this.uploadInput(this.$refs.file);
            });
        },
        uploadFiles(files) {
            const task = new UploadTask(this.id, files);
            if (state.upload.query.length == 0) {
                state.upload.uploaded_bytes = 0;
                state.upload.total_bytes = task.size;
                state.upload.uploaded_files = 0;
                state.upload.error_files = 0;
                state.upload.total_files = files.length;
                upload_tasks.push(task);
                uploadMain(this.$api);
            } else {
                state.upload.total_bytes += task.size;
                state.upload.total_files += files.length;
                upload_tasks.push(task);
            }
        },
        uploadInput(el) {
            const onchange = function () {
                el.onchange = undefined;
                const files = [];
                const l = el.files.length;
                for (let i = 0; i < l; i++) {
                    const file = el.files[i];
                    const name = file.name || file.fileName;
                    if (name) {
                        if ((name !== '.') && (name !== '..')) {
                            files.push(file);
                        }
                    }
                }
                try {
                    el.setAttribute('type', 'text');
                    el.setAttribute('type', 'file');
                } catch (e) {
                    console.log(e);
                }
                this.uploadFiles(files);
            }.bind(this);
            el.onchange = onchange;
            el.focus();
            el.click();
        },
        downloadFiles(files, getMetadata) {
            const promises = [];
            state.download.counter += 1;
            for (let i = 0; i < files.length; i++) {
                const index = i;
                const file = files[index];
                promises.push(new Promise((resolve, reject) => {
                    this.$api.getFile(file.id, true, false)
                        .then((data) => {
                            files[index] = data.file;
                            if (data.file.type == AppConsts.FOLDER_TYPE) {
                                this.$api.getFiles(data.file.id, null, false)
                                    .then((childs) => {
                                        files[index].files = childs.files;
                                        resolve();
                                    })
                                    .catch(reject);
                            } else {
                                resolve();
                            }
                        })
                        .catch(reject);
                }));
            }
            Promise.all(promises)
                .then(() => {
                    downloadMain(this.$api, files, getMetadata);
                })
                .catch(() => {
                    state.download.counter -= 1;
                });
        },
        downloadRevision(id, revision) {
            state.download.counter += 1;
            this.$api.getFile(id, true, false)
                .then((data) => {
                    const { file } = data;
                    file.revision = revision;
                    downloadMain(this.$api, [file]);
                })
                .catch(() => {
                    state.download.counter -= 1;
                });
        },
        onUploadExpand() {
            state.upload.expaned = !state.upload.expaned;
        },
        onDownloadExpand() {
            state.download.expaned = !state.download.expaned;
        },
    },
};
</script>

<style scoped>
.upload-area {
    position: fixed;
    right: 1rem;
    bottom: 1rem;
    pointer-events: auto;
    z-index: 10000;
}
.upload-manager {
    background-color: rgb(var(--v-theme-surface));
    background-clip: padding-box;
    border: 1px solid rgb(var(--v-theme-on-surface-variant));
    border-radius: 0.3rem;
    min-width: 350px;
    overflow: hidden;
}
.upload-manager td,
.table th {
    padding: 0.5rem;
    vertical-align: middle;
}
.header {
    display: flex;
    align-items: center;
    height: 41px;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 8px;
    padding-left: 1rem;
    border-bottom: 1px solid rgb(var(--v-theme-on-surface-variant));
    border-top-left-radius: calc(.3rem - 1px);
    border-top-right-radius: calc(.3rem - 1px);
}

.modal-title {
    margin-bottom: 0;
    line-height: 1.5;
}
</style>
